import { render, staticRenderFns } from "./TheHonorTabs.vue?vue&type=template&id=456c1f41"
import script from "./TheHonorTabs.vue?vue&type=script&lang=js"
export * from "./TheHonorTabs.vue?vue&type=script&lang=js"
import style0 from "./TheHonorTabs.vue?vue&type=style&index=0&id=456c1f41&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports